export default __webpack_public_path__ + "img/bg_key_media-3ed7a62fec66a27835e6e55cdacc4906.jpeg";